import { AuthenticatedUserInfo } from '../../apolloClient/types';

export const initialAuthData: AuthenticatedUserInfo = {
  jwt: '',
  user: {
    id: null,
    username: '',
    assignedLead: {
      id: 0,
    },
  },
};

export const AUTH_DATA = 'authData';
export const LOGIN_AS_USER = 'loginAsUser';
export const CRISP_RESET_PENDING = 'crispResetPending';

// "Continue with Google" (CBBRR-4375). Without a client id at build time the
// feature stays completely hidden — no button, no Google script, no divider.
export const GOOGLE_CLIENT_ID =
  process.env.NEXT_PUBLIC_GOOGLE_OAUTH_CLIENT_ID || '';
export const IS_GOOGLE_AUTH_ENABLED = Boolean(GOOGLE_CLIENT_ID);
// Value of `provider` on users created through Google sign-in.
export const GOOGLE_PROVIDER = 'google';
